import { defaultNavLinkList, defaultUserData } from "constants/defaultValues";
import moment from "moment";
import { AmazonState } from "types/AmazonRecord";
import { AuthState } from "types/Auth";
import { CheckState } from "types/Check";
import { ActState } from "types/Act";
import { DashboardState } from "types/Dashboard";
import { FleetSettingsState } from "types/FleetSettings";
import { DasBoardState } from "types/ShiftTracker";
import { ScorecardState } from "types/Scorecard";
import { WeightsState } from "types/Weights";
import { IkeaCheckState } from "types/IkeaCheck";
import { IkeaActState } from "types/IkeaAct";
import { ModalState } from "types/Modal";
import { DrawerState } from "types/Drawer";
import { CustomGraphsState } from "types/CustomGraphs";
import { PerfomanceState } from "types/Performance";
import { BudgetsState } from "types/Budgets";
import { DaAndFleetState } from "types/DaAndFleet";
import { FalconState } from "types/Falcon";
import { SettingsState } from "types/Settings";
import { ScheduleState } from "types/Schedule";
import { TrackerState } from "types/Tracker";
import { PayrollState } from "types/Payroll";
import { FleetReportsState } from "types/FleetReports";
import { DaFeedbackState } from "types/DaFeedback";
import { DaHomeState } from "types/DaHome";
import { DaNotificationsState } from "types/DaNotifications";
import { PrimeScheduleState } from "types/PrimeSchedule";
import { NavMenuState } from "types/NavMenu";

export const initialAuthState: AuthState = {
  isLoginPending: false,
  isLoginError: false,
  authModalState: false,
  authModalStateLogin: true,
  userData: defaultUserData,
};

export const initialModalState: ModalState = {
  isOpen: false,
  modalName: "",
};

export const initialDrawerState: DrawerState = {
  isOpen: false,
  drawerName: "",
};

export const initialNavMenuState: NavMenuState = {
  isOpen: false,
};

export const defaultRecordFilters = {
  search: "",
  ordering: "-id",
  activeColumns: [
    "id",
    "driver",
    "badge",
    "da_status",
    "is_status_published",
    "role",
    "fleet_size",
    "van",
    "route",
    "wave_time",
    "actual_DA",
    "delete",
  ],
};

export const defaultReportFilters = {
  pageNumber: 0,
  rowsPerPage: 10,
  shiftDate: "",
  shiftDateRange: [],
  week: "",
  month: "",
  year: null,
  fleetVendor: null,
  fleetNumber: null,
  fleetSize: null,
  station: 1,
  driver: null,
  dollySerial: null,
  rabbitSerial: null,
  userCreated: null,
  userUpdated: null,
};

export const initialReportState: DasBoardState = {
  reportListLoading: false,
  reportList: [],
  reportListCount: 1,
  currentReport: [],
  currentReportDate: "",
  currentReportId: 0,
  currentReportStation: { id: 0, title: "" },
  hasSecondDriver: false,
  currentReportDispatchers: [],
  currentReportSupportDispatchers: [],
  currentReportSpecialSupervisor: null,
  currentReportSupervisor: null,
  currentReportLeadDriver: null,
  currentReportFleetCoordinator: null,
  currentReportPerformanceCoordinator: null,
  currentWaveStartTimeList: [],
  reportListFiltersTab: 0,
  reportListFilters: defaultReportFilters,
  recordListFilters: defaultRecordFilters,
  fleetSizeLoading: false,
  fleetGroupLoading: false,
  agencyLoading: false,
  dollyNumberLoading: false,
  rabbitNumberLoading: false,
  fleetSizes: [],
  fleetGroups: [],
  agencies: [],
  uploadFileLoading: false,
  pageListType: "type-shifts",
};

export const initialBudgetState: BudgetsState = {
  budgetList: [],
  budgeListCount: 1,
  loadingData: false,
  budgetsFilters: {
    rowsPerPage: 10,
    pageNumber: 1,
    sort: "",
  },
};

export const initialDashboardState: DashboardState = {
  loadingData: false,
  dashboardDataList: [],
  dashboardDataListCount: 1,
  dashboardModalState: false,
  dashBoardDate: null,
  dashBoardDateLoading: false,
  dashboardSettings: {
    labels: {
      apc: false,
      nd: true,
      nr: true,
      nrs: true,
      nad: false,
    },
    currentLargeScorecard: "TL_PERFORMANCE",
    currentStation: 1,
    stations: [1, 19, 25],
    currentDateTypeScorecardMonthly: true,
    filterType: "date",

    dateFilters: {
      week: `${moment().format("yyyy")}-W${moment().format("W")}`,
      month: `${moment().format("yyyy")}-${moment().format("MM")}`,
      date: moment().format("yyyy-MM-DD"),
      year: moment().format("yyyy"),
      startDate: `${moment().format("yyyy")}-W${moment().format("W")}`,
      endDate: `${moment().format("yyyy")}-W${moment().format("W")}`,
    },
    rejectedDaFilters: {
      driver: null,
    },
  },
  dashboardTableRowsPerPage: 10,
};

export const initialAmazonState: AmazonState = {
  amazonHistoryLoading: false,
  csvHistoryLoading: false,
  amazonHistoryDataList: [],
  csvHistoryDataList: [],
  importHistoryDataListCount: 1,
  importPDFTableRowsPerPage: 10,
  isAmazonPage: true,
};

export const initialScorecardState: ScorecardState = {
  externalSettingActive: false,
  externalSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  daScoreTrendSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
    },
  },
  totalScoreboardSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
    },
  },
  topTenShiftSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  topTenDasSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
    },
  },
  rolesSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  returnSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      startDate: moment().format("yyyy-MM-DD"),
      endDate: moment().format("yyyy-MM-DD"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  vansSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  missingDeliveriesSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  cashOnDeliverySettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  daAvailabilitySettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  daCancelletionSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
      day: moment().format("DD-MM-yyyy"),
    },
  },
  lateAttendanceSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      day: moment().format("DD-MM-yyyy"),
      year: moment().format("yyyy"),
    },
  },
  launchpadSupportSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      day: moment().format("DD-MM-yyyy"),
      year: moment().format("yyyy"),
    },
  },
  morningChecklistSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      day: moment().format("DD-MM-yyyy"),
      year: moment().format("yyyy"),
    },
  },
  rescueSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      day: moment().format("DD-MM-yyyy"),
      year: moment().format("yyyy"),
    },
  },
  returnedDataByDriverSettings: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      day: moment().format("DD-MM-yyyy"),
      year: moment().format("yyyy"),
    },
  },
};

export const initialWeightsState: WeightsState = {
  weightsLoading: false,
  weightsData: null,
};

export const initialFleetSettingsState: FleetSettingsState = {
  isFleetSettingsPending: false,
  fleetSettingsData: [],
  reportListCount: 1,
};

export const initialCheckState: CheckState = {
  loadingData: false,
  dataList: [],
  dataListCount: 1,
  dataTableRowsPerPage: 10,
  currentWeekId: null,
  currentWeekData: null,
  currentWeekLoading: false,
  uploadFileLoading: false,
  changeDataLoading: false,
  avergeScoreData: null,
  reportListFilters: {
    station: "1",
    pageNumber: 0,
    rangeDateOne: "",
    rangeDateTwo: "",
  },
};

export const initialIkeaCheckState: IkeaCheckState = {
  loadingData: false,
  dataList: [],
  dataListCount: 1,
  dataTableRowsPerPage: 10,
  currentWeekId: null,
  currentWeekData: null,
  currentWeekLoading: false,
  changeDataLoading: false,
  avergeScoreData: null,
  reportListFilters: {
    pageNumber: 0,
    rangeDateOne: "",
    rangeDateTwo: "",
  },
};

export const initialActState: ActState = {
  loadingData: false,
  dataList: [],
  dataListCount: 1,
  dataTableRowsPerPage: 10,
  reportListFilters: {
    station: "1",
    pageNumber: 0,
    weekDate: "",
    offTargetArea: null,
    driver: null,
    owner: null,
    action: 0,
    status: 0,
    dueDate: "",
    coachingCount: 0,
    ordering: "-week_number",
  },
};

export const initialIkeaActState: IkeaActState = {
  loadingData: false,
  dataList: [],
  dataListCount: 1,
  dataTableRowsPerPage: 10,
  reportListFilters: {
    pageNumber: 0,
    weekDate: "",
    offTargetArea: null,
    driver: null,
    owner: null,
    action: 0,
    status: 0,
    dueDate: "",
    coachingCount: 0,
    ordering: "-week_number",
  },
};

export const initialCustomGraphState: CustomGraphsState = {
  page: null,
  endpoints: [],
  loadingData: false,
  boards: [],
  pageData: null,
};

export const initialPerformanceState: PerfomanceState = {
  perfomanceSettings: {
    currentScorecard: "TL_PERFORMANCE",
    station: "1",
    selectType: "week",
    date: {
      day: moment().format("d"),
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
    },
  },
};

export const initialDaAndFleetState: DaAndFleetState = {
  loadingData: false,
  driverData: {
    driverList: [],
    driverListCount: 1,
    idListForUpdate: [],
    driverListFilters: {
      selectType: "week",
      dateFilters: {
        date: moment().format("yyyy-MM-DD"),
        week: `${moment().format("yyyy")}-W${moment().format("W")}`,
        month: `${moment().format("yyyy")}-${moment().format("MM")}`,
        year: moment().format("yyyy"),
      },
      pageNumber: 0,
      rowsPerPage: 10,
      ordering: "-id",
      stations: [],
      statuses: [],
      activeColumns: ["full_name", "badge", "transporter_id", "status", "created", "stations"],
    },
  },
  fleetData: {
    fleetList: [],
    fleetListCount: 1,
    idListForUpdate: [],
    fleetListFilters: {
      selectType: "week",
      dateFilters: {
        date: moment().format("yyyy-MM-DD"),
        week: `${moment().format("yyyy")}-W${moment().format("W")}`,
        month: `${moment().format("yyyy")}-${moment().format("MM")}`,
        year: moment().format("yyyy"),
      },
      pageNumber: 0,
      rowsPerPage: 10,
      ordering: "-id",
      stations: [],
      statuses: [],
      activeColumns: ["number", "van_group", "fleet_size", "plate_number", "status", "comment"],
    },
  },
};

export const initialFalconState: FalconState = {
  loadingData: false,
  falconData: {
    dateList: [],
    standardList: [],
    planList: [],
    commentList: [],
  },
  falconFilters: {
    pageNumber: 0,
    station: "1",
    selectType: "week",
    date: {
      week: `${moment().format("yyyy")}-W${moment().format("W")}`,
      month: `${moment().format("yyyy")}-${moment().format("MM")}`,
    },
  },
};

export const initialTrackerState: TrackerState = {
  loadingData: false,
  dataList: [],
  trackerFilters: {
    station: "1",
    selectType: "week",
    date: {
      week: moment().format("W"),
      month: moment().format("M"),
      year: moment().format("yyyy"),
    },
  },
};

export const initialScheduleState: ScheduleState = {
  loadingData: false,
  dateList: [],
  planList: [],
  dataList: [],
  userList: [],
  idListForCopy: [],
  idListForDelete: [],
  idListForSMS: [],
  mode: "manual",
  reportCopy: null,
  scheduleFilters: {
    activeColumns: [
      "checkbox",
      "user",
      "badge",
      "hours",
      "role",
      "transporter_id",
      "payroll",
      "tenured",
    ],
    statusList: [1],
    userRoles: [],
    shiftRoles: [],
    station: 1,
    search: "",
    week_date: `${moment().format("yyyy")}-W${moment().format("W")}`,
    ordering: "-name",
    isTwoWeekTable: false,
  },
};

export const initialPrimeScheduleState: PrimeScheduleState = {
  loadingData: false,
  dateList: [],
  dataList: [],
  userList: [],
  primeScheduleFilters: {
    station: "1",
    week_date: `${moment().format("yyyy")}-W${moment().format("W")}`,
  },
};

export const initialPayrollState: PayrollState = {
  loadingData: false,
  userList: [],
  dataList: [],
  selctedUserDatesList: [],
  payrollFilters: {
    type: "week",
    user: null,
    search: "",
    station: 1,
    userRole: 0,
    userStatus: 1,
    week_date: `${moment().format("yyyy")}-W${moment().format("W")}`,
    year: moment().format("yyyy"),
    month: moment().format("M"),
    rangeDateOne: `${moment().format("yyyy")}-W${moment().format("W")}`,
    rangeDateTwo: `${moment().format("yyyy")}-W${moment().format("W")}`,
    ordering: "user",
  },
};

export const initialFleetReportsState: FleetReportsState = {
  loadingData: false,
  offBoardedFleetReportList: [],
  fleetReportList: [],
  selectedIdList: [],
  fleetReportFilters: {
    month: moment().format("M"),
    year: moment().format("yyyy"),
    statuses: [0, 1, 3],
    showActual: false,
    invoice: 0,
    company: 0,
    search: "",
    ordering: "van_number",
    fixedColumns: [],
    activeColumns: [
      "company",
      "model",
      "station",
      "size",
      "van_number",
      "plate",
      "vin",
      "onboarded_date",
      "offboarded_date",
      "rate",
      "invoice",
      "payroll_comment",
      "rental_period",
      "invoice_date",
      "rental_period_to",
      "paid_amount",
      "payment_date",
      "invoice_number",
      "payment_method",
      "deductibles_amount",
      "deductibles_invoice_number",
      "deductibles_payment_date",
      "deductibles_paid_amount",
      "deductibles_payment_method",
    ],
  },
};

export const initialSettingsState: SettingsState = {
  activeNavLinkList: defaultNavLinkList,
};

export const initialDaFeedbackState: DaFeedbackState = {
  loadingData: false,
  dataList: [],
  currentReport: null,
  feedbackListCount: 0,
  feedbackFilters: {
    rowsPerPage: 10,
    pageNumber: 0,
  },
};

export const initialDaHomeState: DaHomeState = {
  loadingData: false,
  dataList: [],
  homeFilters: {
    year: moment().format("yyyy"),
    month: moment().format("M"),
  },
};

export const initialDaNotificationsState: DaNotificationsState = {
  loadingData: false,
  isDrawerOpen: false,
  notificationsList: [],
};
